import { gql } from '@apollo/client';

export const CANCEL_RECURRING_ACTION_MUTATION = gql`
  mutation cancelRecurringActionMutation($recurringActionId: String!) {
    cancelRecurringAction(recurringActionId: $recurringActionId) {
      ok
    }
  }
`;
